import React, { useMemo } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import PropTypes from 'prop-types';
import "./styles.scss";

const MegaMenuHover = ({ filters, onChangeFilter }) => {
    const productosFilter = useMemo(() => filters.find(filter => filter.title === "Productos"), [filters]);

    const sections = [
        {
            title: "REFRIGERACIÓN DE MOTOR",
            keywords: [
                "RADIADORES", "RADIADORES LINEA PESADA", "INTERCOOLERS", "ENFRIADORES DE ACEITE", "TERMOSTATOS DE MOTOR",
                "VISCOSOS", "BOMBAS DE AGUA", "RADIADORES DE CALEFACCION", "MOTORES DE CALEFACCION / FORZADORES", "GRIFOS DE CALEFACCION",
                "HELICES DE CALEFACCION", "ELECTROVENTILADORES", "SOPORTES DE ELECTROVENTILADORES", "MOTORES DE ELECTROVENTILADORES",
                "HELICES DE ELECTROVENTILADORES"
            ]
        },
        {
            title: "AIRE ACONDICIONADO",
            keywords: [
                "CONDENSADORES", "COMPRESORES", "EVAPORADORES", "EQUIPOS DE AIRE ACONDICIONADO", "GARRAFAS DE GAS",
                "EMBRAGUE, TAPA DE COMPRESOR Y POLEA", "BOBINAS DE COMPRESOR", "PARTES DEL COMPRESOR / SOPORTES", "ORING SELLO JUNTA RETEN",
                "FILTROS AA - TUBOS RECIBIDORES", "MANGUERAS ACCESORIOS", "VALVULAS", "RESISTORES", "PRESOSTATOS",
                "TERMOSTATOS AA", "HERRAMIENTAS", "ACCESORIOS DE AIRE ACONDICIONADO"
            ]
        },
        {
            title: "OTROS",
            keywords: [
                "OTROS", "EGR", "SONDAS LAMBDA", "ADITIVOS", "CALEFACTORES COMPLETOS UNIVERSALES", "ACCESORIOS VARIOS",
                "PANELES", "ACCESORIOS DE RADIADOR"
            ]
        },
    ];

    const isSectionVisible = (title) =>
        title === "BOMBAS DE AGUA" || title === "HELICES DE CALEFACCION" || title === "ACCESORIOS VARIOS";

    return (
        <div style={{ position: 'relative' }}>
            <div className="megamenu">
                <div className="megamenu_display">
                    {productosFilter && sections.map((section, index) => {
                        const sectionOptions = section.keywords
                            .map(keyword => productosFilter.options.find(option => option.title.includes(keyword)))
                            .filter(Boolean);

                        if (sectionOptions.length > 0) {
                            return (
                                <div key={index} className="section section-megamenu">
                                    <h4>{section.title}</h4>
                                    <div className="product-grid">
                                        {sectionOptions.map((option, index) => (
                                            <div className="product-item" key={index}>
                                                <a href={`https://www.darsur.com.ar/#/productos/h7mn/PRODUCTOS/-l${option.code}`}>
                                                    <label style={{ marginBottom: isSectionVisible(option.title) ? '30px' : '0' }}>
                                                        {option.title}
                                                    </label>
                                                </a>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            );
                        }
                        return null;
                    })}
                </div>
            </div>
        </div>
    );
};

MegaMenuHover.propTypes = {
    filters: PropTypes.array,
    onChangeFilter: PropTypes.func
};

export default MegaMenuHover;



// WEBPACK FOOTER //
// ./src/views/Productos/MegaMenu.js